import clsx from 'clsx';
import type { ReactNode } from 'react';

import styles from './Badge.module.css';

export type BadgeTone = 'neutral' | 'accent' | 'signal' | 'success' | 'warning' | 'danger';

export interface BadgeProps {
  tone?: BadgeTone;
  dot?: boolean;
  className?: string;
  children: ReactNode;
}

export function Badge({ tone = 'neutral', dot = false, className, children }: BadgeProps) {
  return (
    <span className={clsx(styles.badge, styles[tone], className)}>
      {dot ? <span className={styles.dot} /> : null}
      {children}
    </span>
  );
}
